export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    PROFILE: '/auth/profile',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh-token',
  },
  USERS: {
    GET_ALL: '/users',
    GET_BY_ID: (id: string) => `/users/${id}`,
    CREATE: '/users',
    UPDATE: (id: string) => `/users/${id}`,
    DELETE: (id: string) => `/users/${id}`,
  },
  STUDENTS: {
    GET_ALL: '/students',
    GET_BY_ID: (id: string) => `/students/${id}`,
    CREATE: '/students',
    UPDATE: (id: string) => `/students/${id}`,
    DELETE: (id: string) => `/students/${id}`,
  },
  STAFF: {
    GET_ALL: '/staff',
    GET_BY_ID: (id: string) => `/staff/${id}`,
    CREATE: '/staff',
    UPDATE: (id: string) => `/staff/${id}`,
    DELETE: (id: string) => `/staff/${id}`,
  },
  PARENTS: {
    GET_ALL: '/parents',
    GET_BY_ID: (id: string) => `/parents/${id}`,
    CREATE: '/parents',
    UPDATE: (id: string) => `/parents/${id}`,
    DELETE: (id: string) => `/parents/${id}`,
  },
  FILES: {
    UPLOAD: '/files/upload',
    DELETE: (id: string) => `/files/${id}`,
    DOWNLOAD: (id: string) => `/files/download/${id}`,
  },
  ATTENDANCE: {
    SAVE: '/attendance',
    GET_BY_DATE: '/attendance/by-date',
    GET_BY_STANDARD_SECTION: '/attendance/by-standard-section',
  },
} as const;